module.exports = __webpack_public_path__ + "static/img/login_logo.c9ed62a8.png";